import { render, staticRenderFns } from "./IdProtect.vue?vue&type=template&id=6287e2ff&"
import script from "./IdProtect.vue?vue&type=script&lang=js&"
export * from "./IdProtect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6287e2ff')) {
      api.createRecord('6287e2ff', component.options)
    } else {
      api.reload('6287e2ff', component.options)
    }
    module.hot.accept("./IdProtect.vue?vue&type=template&id=6287e2ff&", function () {
      api.rerender('6287e2ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DomainOptions/IdProtect.vue"
export default component.exports